/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as AnnouncementsRouteImport } from "./routes/announcements";
import { Route as AuditRouteImport } from "./routes/audit";
import { Route as DiagnosticsRouteImport } from "./routes/diagnostics";
import { Route as ExceptionsRouteImport } from "./routes/exceptions";
import { Route as LeadsRouteImport } from "./routes/leads";
import { Route as OperatorsRouteImport } from "./routes/operators";
import { Route as PlansRouteImport } from "./routes/plans";
import { Route as PromotionsRouteImport } from "./routes/promotions";
import { Route as ReportsRouteImport } from "./routes/reports";
import { Route as SignedOutRouteImport } from "./routes/signed-out";
import { Route as SupportRouteImport } from "./routes/support";
import { Route as FeedbackIndexRouteImport } from "./routes/feedback.index";
import { Route as FeedbackIdRouteImport } from "./routes/feedback.$id";
import { Route as TenantsIndexRouteImport } from "./routes/tenants.index";
import { Route as TenantsTenantIdRouteImport } from "./routes/tenants.$tenantId";
import { Route as TenantsTenantIdIndexRouteImport } from "./routes/tenants.$tenantId.index";
import { Route as TenantsTenantIdAuditRouteImport } from "./routes/tenants.$tenantId.audit";
import { Route as TenantsTenantIdHealthRouteImport } from "./routes/tenants.$tenantId.health";
import { Route as TenantsTenantIdPlanRouteImport } from "./routes/tenants.$tenantId.plan";
import { Route as TenantsTenantIdUsageRouteImport } from "./routes/tenants.$tenantId.usage";
import { Route as TenantsTenantIdUsersRouteImport } from "./routes/tenants.$tenantId.users";

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const AnnouncementsRoute = AnnouncementsRouteImport.update({
  id: "/announcements",
  path: "/announcements",
  getParentRoute: () => rootRouteImport,
} as any);
const AuditRoute = AuditRouteImport.update({
  id: "/audit",
  path: "/audit",
  getParentRoute: () => rootRouteImport,
} as any);
const DiagnosticsRoute = DiagnosticsRouteImport.update({
  id: "/diagnostics",
  path: "/diagnostics",
  getParentRoute: () => rootRouteImport,
} as any);
const ExceptionsRoute = ExceptionsRouteImport.update({
  id: "/exceptions",
  path: "/exceptions",
  getParentRoute: () => rootRouteImport,
} as any);
const LeadsRoute = LeadsRouteImport.update({
  id: "/leads",
  path: "/leads",
  getParentRoute: () => rootRouteImport,
} as any);
const OperatorsRoute = OperatorsRouteImport.update({
  id: "/operators",
  path: "/operators",
  getParentRoute: () => rootRouteImport,
} as any);
const PlansRoute = PlansRouteImport.update({
  id: "/plans",
  path: "/plans",
  getParentRoute: () => rootRouteImport,
} as any);
const PromotionsRoute = PromotionsRouteImport.update({
  id: "/promotions",
  path: "/promotions",
  getParentRoute: () => rootRouteImport,
} as any);
const ReportsRoute = ReportsRouteImport.update({
  id: "/reports",
  path: "/reports",
  getParentRoute: () => rootRouteImport,
} as any);
const SignedOutRoute = SignedOutRouteImport.update({
  id: "/signed-out",
  path: "/signed-out",
  getParentRoute: () => rootRouteImport,
} as any);
const SupportRoute = SupportRouteImport.update({
  id: "/support",
  path: "/support",
  getParentRoute: () => rootRouteImport,
} as any);
const FeedbackIndexRoute = FeedbackIndexRouteImport.update({
  id: "/feedback/",
  path: "/feedback/",
  getParentRoute: () => rootRouteImport,
} as any);
const FeedbackIdRoute = FeedbackIdRouteImport.update({
  id: "/feedback/$id",
  path: "/feedback/$id",
  getParentRoute: () => rootRouteImport,
} as any);
const TenantsIndexRoute = TenantsIndexRouteImport.update({
  id: "/tenants/",
  path: "/tenants/",
  getParentRoute: () => rootRouteImport,
} as any);
const TenantsTenantIdRoute = TenantsTenantIdRouteImport.update({
  id: "/tenants/$tenantId",
  path: "/tenants/$tenantId",
  getParentRoute: () => rootRouteImport,
} as any);
const TenantsTenantIdIndexRoute = TenantsTenantIdIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => TenantsTenantIdRoute,
} as any);
const TenantsTenantIdAuditRoute = TenantsTenantIdAuditRouteImport.update({
  id: "/audit",
  path: "/audit",
  getParentRoute: () => TenantsTenantIdRoute,
} as any);
const TenantsTenantIdHealthRoute = TenantsTenantIdHealthRouteImport.update({
  id: "/health",
  path: "/health",
  getParentRoute: () => TenantsTenantIdRoute,
} as any);
const TenantsTenantIdPlanRoute = TenantsTenantIdPlanRouteImport.update({
  id: "/plan",
  path: "/plan",
  getParentRoute: () => TenantsTenantIdRoute,
} as any);
const TenantsTenantIdUsageRoute = TenantsTenantIdUsageRouteImport.update({
  id: "/usage",
  path: "/usage",
  getParentRoute: () => TenantsTenantIdRoute,
} as any);
const TenantsTenantIdUsersRoute = TenantsTenantIdUsersRouteImport.update({
  id: "/users",
  path: "/users",
  getParentRoute: () => TenantsTenantIdRoute,
} as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/announcements": typeof AnnouncementsRoute;
  "/audit": typeof AuditRoute;
  "/diagnostics": typeof DiagnosticsRoute;
  "/exceptions": typeof ExceptionsRoute;
  "/leads": typeof LeadsRoute;
  "/operators": typeof OperatorsRoute;
  "/plans": typeof PlansRoute;
  "/promotions": typeof PromotionsRoute;
  "/reports": typeof ReportsRoute;
  "/signed-out": typeof SignedOutRoute;
  "/support": typeof SupportRoute;
  "/feedback/$id": typeof FeedbackIdRoute;
  "/tenants/$tenantId": typeof TenantsTenantIdRouteWithChildren;
  "/feedback/": typeof FeedbackIndexRoute;
  "/tenants/": typeof TenantsIndexRoute;
  "/tenants/$tenantId/audit": typeof TenantsTenantIdAuditRoute;
  "/tenants/$tenantId/health": typeof TenantsTenantIdHealthRoute;
  "/tenants/$tenantId/plan": typeof TenantsTenantIdPlanRoute;
  "/tenants/$tenantId/usage": typeof TenantsTenantIdUsageRoute;
  "/tenants/$tenantId/users": typeof TenantsTenantIdUsersRoute;
  "/tenants/$tenantId/": typeof TenantsTenantIdIndexRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/announcements": typeof AnnouncementsRoute;
  "/audit": typeof AuditRoute;
  "/diagnostics": typeof DiagnosticsRoute;
  "/exceptions": typeof ExceptionsRoute;
  "/leads": typeof LeadsRoute;
  "/operators": typeof OperatorsRoute;
  "/plans": typeof PlansRoute;
  "/promotions": typeof PromotionsRoute;
  "/reports": typeof ReportsRoute;
  "/signed-out": typeof SignedOutRoute;
  "/support": typeof SupportRoute;
  "/feedback/$id": typeof FeedbackIdRoute;
  "/feedback": typeof FeedbackIndexRoute;
  "/tenants": typeof TenantsIndexRoute;
  "/tenants/$tenantId/audit": typeof TenantsTenantIdAuditRoute;
  "/tenants/$tenantId/health": typeof TenantsTenantIdHealthRoute;
  "/tenants/$tenantId/plan": typeof TenantsTenantIdPlanRoute;
  "/tenants/$tenantId/usage": typeof TenantsTenantIdUsageRoute;
  "/tenants/$tenantId/users": typeof TenantsTenantIdUsersRoute;
  "/tenants/$tenantId": typeof TenantsTenantIdIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/announcements": typeof AnnouncementsRoute;
  "/audit": typeof AuditRoute;
  "/diagnostics": typeof DiagnosticsRoute;
  "/exceptions": typeof ExceptionsRoute;
  "/leads": typeof LeadsRoute;
  "/operators": typeof OperatorsRoute;
  "/plans": typeof PlansRoute;
  "/promotions": typeof PromotionsRoute;
  "/reports": typeof ReportsRoute;
  "/signed-out": typeof SignedOutRoute;
  "/support": typeof SupportRoute;
  "/feedback/$id": typeof FeedbackIdRoute;
  "/tenants/$tenantId": typeof TenantsTenantIdRouteWithChildren;
  "/feedback/": typeof FeedbackIndexRoute;
  "/tenants/": typeof TenantsIndexRoute;
  "/tenants/$tenantId/audit": typeof TenantsTenantIdAuditRoute;
  "/tenants/$tenantId/health": typeof TenantsTenantIdHealthRoute;
  "/tenants/$tenantId/plan": typeof TenantsTenantIdPlanRoute;
  "/tenants/$tenantId/usage": typeof TenantsTenantIdUsageRoute;
  "/tenants/$tenantId/users": typeof TenantsTenantIdUsersRoute;
  "/tenants/$tenantId/": typeof TenantsTenantIdIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/announcements"
    | "/audit"
    | "/diagnostics"
    | "/exceptions"
    | "/leads"
    | "/operators"
    | "/plans"
    | "/promotions"
    | "/reports"
    | "/signed-out"
    | "/support"
    | "/feedback/$id"
    | "/tenants/$tenantId"
    | "/feedback/"
    | "/tenants/"
    | "/tenants/$tenantId/audit"
    | "/tenants/$tenantId/health"
    | "/tenants/$tenantId/plan"
    | "/tenants/$tenantId/usage"
    | "/tenants/$tenantId/users"
    | "/tenants/$tenantId/";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/announcements"
    | "/audit"
    | "/diagnostics"
    | "/exceptions"
    | "/leads"
    | "/operators"
    | "/plans"
    | "/promotions"
    | "/reports"
    | "/signed-out"
    | "/support"
    | "/feedback/$id"
    | "/feedback"
    | "/tenants"
    | "/tenants/$tenantId/audit"
    | "/tenants/$tenantId/health"
    | "/tenants/$tenantId/plan"
    | "/tenants/$tenantId/usage"
    | "/tenants/$tenantId/users"
    | "/tenants/$tenantId";
  id:
    | "__root__"
    | "/"
    | "/announcements"
    | "/audit"
    | "/diagnostics"
    | "/exceptions"
    | "/leads"
    | "/operators"
    | "/plans"
    | "/promotions"
    | "/reports"
    | "/signed-out"
    | "/support"
    | "/feedback/$id"
    | "/tenants/$tenantId"
    | "/feedback/"
    | "/tenants/"
    | "/tenants/$tenantId/audit"
    | "/tenants/$tenantId/health"
    | "/tenants/$tenantId/plan"
    | "/tenants/$tenantId/usage"
    | "/tenants/$tenantId/users"
    | "/tenants/$tenantId/";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AnnouncementsRoute: typeof AnnouncementsRoute;
  AuditRoute: typeof AuditRoute;
  DiagnosticsRoute: typeof DiagnosticsRoute;
  ExceptionsRoute: typeof ExceptionsRoute;
  LeadsRoute: typeof LeadsRoute;
  OperatorsRoute: typeof OperatorsRoute;
  PlansRoute: typeof PlansRoute;
  PromotionsRoute: typeof PromotionsRoute;
  ReportsRoute: typeof ReportsRoute;
  SignedOutRoute: typeof SignedOutRoute;
  SupportRoute: typeof SupportRoute;
  FeedbackIdRoute: typeof FeedbackIdRoute;
  TenantsTenantIdRoute: typeof TenantsTenantIdRouteWithChildren;
  FeedbackIndexRoute: typeof FeedbackIndexRoute;
  TenantsIndexRoute: typeof TenantsIndexRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/announcements": {
      id: "/announcements";
      path: "/announcements";
      fullPath: "/announcements";
      preLoaderRoute: typeof AnnouncementsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/audit": {
      id: "/audit";
      path: "/audit";
      fullPath: "/audit";
      preLoaderRoute: typeof AuditRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/diagnostics": {
      id: "/diagnostics";
      path: "/diagnostics";
      fullPath: "/diagnostics";
      preLoaderRoute: typeof DiagnosticsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/exceptions": {
      id: "/exceptions";
      path: "/exceptions";
      fullPath: "/exceptions";
      preLoaderRoute: typeof ExceptionsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/leads": {
      id: "/leads";
      path: "/leads";
      fullPath: "/leads";
      preLoaderRoute: typeof LeadsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/operators": {
      id: "/operators";
      path: "/operators";
      fullPath: "/operators";
      preLoaderRoute: typeof OperatorsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/plans": {
      id: "/plans";
      path: "/plans";
      fullPath: "/plans";
      preLoaderRoute: typeof PlansRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/promotions": {
      id: "/promotions";
      path: "/promotions";
      fullPath: "/promotions";
      preLoaderRoute: typeof PromotionsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/reports": {
      id: "/reports";
      path: "/reports";
      fullPath: "/reports";
      preLoaderRoute: typeof ReportsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/signed-out": {
      id: "/signed-out";
      path: "/signed-out";
      fullPath: "/signed-out";
      preLoaderRoute: typeof SignedOutRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/support": {
      id: "/support";
      path: "/support";
      fullPath: "/support";
      preLoaderRoute: typeof SupportRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/feedback/": {
      id: "/feedback/";
      path: "/feedback";
      fullPath: "/feedback/";
      preLoaderRoute: typeof FeedbackIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/feedback/$id": {
      id: "/feedback/$id";
      path: "/feedback/$id";
      fullPath: "/feedback/$id";
      preLoaderRoute: typeof FeedbackIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/tenants/": {
      id: "/tenants/";
      path: "/tenants";
      fullPath: "/tenants/";
      preLoaderRoute: typeof TenantsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/tenants/$tenantId": {
      id: "/tenants/$tenantId";
      path: "/tenants/$tenantId";
      fullPath: "/tenants/$tenantId";
      preLoaderRoute: typeof TenantsTenantIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/tenants/$tenantId/": {
      id: "/tenants/$tenantId/";
      path: "/";
      fullPath: "/tenants/$tenantId/";
      preLoaderRoute: typeof TenantsTenantIdIndexRouteImport;
      parentRoute: typeof TenantsTenantIdRoute;
    };
    "/tenants/$tenantId/audit": {
      id: "/tenants/$tenantId/audit";
      path: "/audit";
      fullPath: "/tenants/$tenantId/audit";
      preLoaderRoute: typeof TenantsTenantIdAuditRouteImport;
      parentRoute: typeof TenantsTenantIdRoute;
    };
    "/tenants/$tenantId/health": {
      id: "/tenants/$tenantId/health";
      path: "/health";
      fullPath: "/tenants/$tenantId/health";
      preLoaderRoute: typeof TenantsTenantIdHealthRouteImport;
      parentRoute: typeof TenantsTenantIdRoute;
    };
    "/tenants/$tenantId/plan": {
      id: "/tenants/$tenantId/plan";
      path: "/plan";
      fullPath: "/tenants/$tenantId/plan";
      preLoaderRoute: typeof TenantsTenantIdPlanRouteImport;
      parentRoute: typeof TenantsTenantIdRoute;
    };
    "/tenants/$tenantId/usage": {
      id: "/tenants/$tenantId/usage";
      path: "/usage";
      fullPath: "/tenants/$tenantId/usage";
      preLoaderRoute: typeof TenantsTenantIdUsageRouteImport;
      parentRoute: typeof TenantsTenantIdRoute;
    };
    "/tenants/$tenantId/users": {
      id: "/tenants/$tenantId/users";
      path: "/users";
      fullPath: "/tenants/$tenantId/users";
      preLoaderRoute: typeof TenantsTenantIdUsersRouteImport;
      parentRoute: typeof TenantsTenantIdRoute;
    };
  }
}

interface TenantsTenantIdRouteChildren {
  TenantsTenantIdAuditRoute: typeof TenantsTenantIdAuditRoute;
  TenantsTenantIdHealthRoute: typeof TenantsTenantIdHealthRoute;
  TenantsTenantIdPlanRoute: typeof TenantsTenantIdPlanRoute;
  TenantsTenantIdUsageRoute: typeof TenantsTenantIdUsageRoute;
  TenantsTenantIdUsersRoute: typeof TenantsTenantIdUsersRoute;
  TenantsTenantIdIndexRoute: typeof TenantsTenantIdIndexRoute;
}

const TenantsTenantIdRouteChildren: TenantsTenantIdRouteChildren = {
  TenantsTenantIdAuditRoute: TenantsTenantIdAuditRoute,
  TenantsTenantIdHealthRoute: TenantsTenantIdHealthRoute,
  TenantsTenantIdPlanRoute: TenantsTenantIdPlanRoute,
  TenantsTenantIdUsageRoute: TenantsTenantIdUsageRoute,
  TenantsTenantIdUsersRoute: TenantsTenantIdUsersRoute,
  TenantsTenantIdIndexRoute: TenantsTenantIdIndexRoute,
};

const TenantsTenantIdRouteWithChildren = TenantsTenantIdRoute._addFileChildren(
  TenantsTenantIdRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AnnouncementsRoute: AnnouncementsRoute,
  AuditRoute: AuditRoute,
  DiagnosticsRoute: DiagnosticsRoute,
  ExceptionsRoute: ExceptionsRoute,
  LeadsRoute: LeadsRoute,
  OperatorsRoute: OperatorsRoute,
  PlansRoute: PlansRoute,
  PromotionsRoute: PromotionsRoute,
  ReportsRoute: ReportsRoute,
  SignedOutRoute: SignedOutRoute,
  SupportRoute: SupportRoute,
  FeedbackIdRoute: FeedbackIdRoute,
  TenantsTenantIdRoute: TenantsTenantIdRouteWithChildren,
  FeedbackIndexRoute: FeedbackIndexRoute,
  TenantsIndexRoute: TenantsIndexRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
